import { GraviButton, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { formatDateStringToTime } from '@utils/general'
/* eslint-disable sort-imports */
import { Col, Popover, Row } from 'antd'
import { TripStatusIcon } from '../../../../constants/TripStatusIcons'
import { translateStatus } from '../../../../constants/orderDispatch'

import { CheckCircleFilled, EnvironmentOutlined } from '@ant-design/icons'

export const ModernTripStatus = ({ status }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'driving to load':
      case 'driving to drop':
      case 'heading home':
        return {
          icon: <DrivingIcon size={16} />,
          text: 'DRIVING',

          theme2: true,
        }
      case 'loading':
        return {
          icon: <LoadingIcon size={16} />,
          text: 'LOAD',

          theme2: true,
        }
      case 'dropping':
        return {
          icon: <DroppingIcon size={16} />,
          text: 'DROP',

          theme2: true,
        }
      case 'arrived at load':
      case 'arrived at drop':
        return {
          icon: <EnvironmentOutlined />,
          theme2: true,
          text: 'ARRIVED',
        }
      case 'complete':
        return {
          icon: <CheckCircleFilled />,
          text: 'COMPLETED',
          success: true,
        }
      default:
        return null
    }
  }

  const config = getStatusConfig(status)
  if (!config) return null

  return (
    <GraviButton
      size='small'
      {...{ [config.theme]: true }}
      appearance='solid'
      style={{
        height: 22,
        width: 30,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: config.success && 'var(--theme-success)',
      }}
      theme2={config.theme2}
      color={config.success && 'var(--theme-success)'}
      icon={config.icon}
    />
  )
}

export const TripStatusHover = ({ trip, status, currentStatusClass }) => {
  return (
    <Popover
      content={<TripStatusPopoverContent trip={trip} status={status} currentStatusClass={currentStatusClass} />}
      title={<StatusTitle trip={trip} />}
      trigger='hover'
      styles={{ root: { width: '450px' } }}
    >
      <div style={{ cursor: 'pointer' }}>
        <ModernTripStatus status={status} />
      </div>
    </Popover>
  )
}

const TripStatusPopoverContent = ({ trip, status }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'complete':
        return 'success'
      case 'unset':
        return 'default'
      default:
        return 'primary'
    }
  }
  return (
    <Row>
      <Col flex={2}>
        <Texto category='label' weight='600' className='popover-subtitle'>
          Current Status
        </Texto>
        <Horizontal gap={8} verticalCenter className='popover-icon'>
          <Texto
            weight='600'
            style={{ display: 'flex', alignItems: 'center', gap: 4 }}
            category='p1'
            appearance={getStatusColor(status)}
            className={`popover-status-text `}
          >
            <TripStatusIcon status={status} />
            {translateStatus[status]}
          </Texto>
        </Horizontal>
      </Col>
      <Col flex={1} align='right'>
        <Texto category='label' weight='600' className='popover-subtitle'>
          At:
        </Texto>
        <div>
          <p className='popover-city-text'>{trip.status_detail?.location_name}</p>
        </div>
      </Col>
    </Row>
  )
}

const StatusTitle = ({ trip }) => {
  const timeData = trip.status_detail?.updated
  const formattedTime = formatDateStringToTime(timeData)
  return (
    <Horizontal verticalCenter align='middle'>
      <Col flex={1}>
        <div className='popover-title'>Order Status</div>
      </Col>
      <Col>
        <div className='popover-title'>
          Updated: <span className='update-time'>{formattedTime}</span>
        </div>
      </Col>
    </Horizontal>
  )
}
export const DrivingIcon = ({ size, color, className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox='0 0 13 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill={color || 'white'}
        d='M6.78522 0.450195C3.52196 0.450185 0.530293 3.38353 0.802463 6.58353C0.802463 9.8185 3.48647 12.4502 6.78528 12.4502C10.0841 12.4502 12.768 9.8185 12.768 6.58353C13.0399 3.38353 10.0485 0.450205 6.78522 0.450195ZM11.5224 6.58353C11.5224 7.36849 11.3219 8.10828 10.9699 8.7571L8.58504 7.23425C8.66138 7.03138 8.70302 6.81232 8.70302 6.58364C8.70302 5.68874 8.06525 4.9404 7.21138 4.75032V1.95825C9.62441 2.17039 11.5224 4.1633 11.5224 6.58353ZM6.35907 1.95825V4.7502C5.5052 4.9404 4.86743 5.68875 4.86743 6.58353C4.86743 6.81233 4.90943 7.03139 4.98553 7.23415L2.60065 8.7571C2.24874 8.10828 2.04844 7.36849 2.04844 6.58353C2.04832 4.1633 3.94619 2.17039 6.35907 1.95825ZM6.78528 11.2286C5.27881 11.2286 3.93554 10.5347 3.06731 9.4566L5.45147 7.93404C5.79668 8.26175 6.26669 8.46399 6.78528 8.46399C7.30363 8.46399 7.77389 8.26175 8.11909 7.93404L10.5032 9.4566C9.63531 10.5347 8.29152 11.2286 6.78528 11.2286Z'
      />
    </svg>
  )
}
export const DroppingIcon = ({ size, color, className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size * 0.75}
      viewBox='0 0 12 9'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill={color || 'white'}
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M1.37522 4.25588L4.06128 1.03405C4.27307 0.779064 4.23828 0.400485 3.98449 0.188695C3.7289 -0.0230954 3.35152 0.0111045 3.13853 0.265494L0.138689 3.8653C-0.0437015 4.08489 -0.0467015 4.40287 0.132688 4.62546L3.02934 8.22532C3.14813 8.37232 3.32152 8.44902 3.49731 8.44902C3.62931 8.44902 3.7625 8.40582 3.87289 8.31712C4.13148 8.10892 4.17168 7.73152 3.96409 7.47292L1.37522 4.25588ZM11.8674 3.87392L8.97079 0.274115C8.76199 0.0161247 8.38459 -0.0258754 8.12719 0.182915C7.8686 0.390505 7.8284 0.767885 8.03539 1.02647L10.6249 4.2435L7.9388 7.46532C7.72701 7.72032 7.7612 8.09892 8.01559 8.31132C8.12839 8.40432 8.26399 8.44992 8.39959 8.44992C8.57179 8.44992 8.74219 8.37672 8.86099 8.23452L11.8608 4.63468C12.0438 4.4145 12.0468 4.09651 11.8674 3.87392ZM7.38293 3.88071C7.62052 3.65032 8.00149 3.65812 8.23129 3.89571C8.46109 4.1339 8.45449 4.51368 8.21629 4.74406L6.41638 6.48222C6.29999 6.59372 6.1494 6.65012 5.9994 6.65012C5.84581 6.65012 5.69282 6.59132 5.57523 6.47442L3.77532 4.67447C3.54133 4.43988 3.54133 4.0601 3.77532 3.82611C4.00991 3.59152 4.38969 3.59152 4.62367 3.82611L5.39943 4.60127V1.85041C5.39943 1.51863 5.66822 1.25044 5.9994 1.25044C6.33119 1.25044 6.59937 1.51863 6.59937 1.85041V4.63667L7.38293 3.88071Z'
      />
    </svg>
  )
}
export const LoadingIcon = ({ size, color, className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size * 0.75}
      viewBox='0 0 12 9'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill={color || 'white'}
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.37522 4.24414L4.06128 7.46597C4.27307 7.72096 4.23828 8.09954 3.98449 8.31133C3.7289 8.52312 3.35152 8.48892 3.13853 8.23453L0.138689 4.63472C-0.0437015 4.41513 -0.0467015 4.09715 0.132688 3.87456L3.02934 0.274703C3.14813 0.127703 3.32152 0.0510025 3.49731 0.0510025C3.62931 0.0510025 3.7625 0.0942025 3.87289 0.182903C4.13148 0.391103 4.17168 0.768503 3.96409 1.0271L1.37522 4.24414ZM11.8674 4.62610L8.97079 8.22591C8.76199 8.48390 8.38459 8.52590 8.12719 8.31711C7.8686 8.10952 7.8284 7.73214 8.03539 7.47355L10.6249 4.25652L7.9388 1.03470C7.72701 0.779705 7.7612 0.401105 8.01559 0.188705C8.12839 0.0957052 8.26399 0.0501051 8.39959 0.0501051C8.57179 0.0501051 8.74219 0.123305 8.86099 0.265505L11.8608 3.86534C12.0438 4.08552 12.0468 4.40351 11.8674 4.62610ZM7.38293 4.61931C7.62052 4.84970 8.00149 4.84190 8.23129 4.60431C8.46109 4.36612 8.45449 3.98634 8.21629 3.75596L6.41638 2.01780C6.29999 1.90630 6.1494 1.84990 5.9994 1.84990C5.84581 1.84990 5.69282 1.90870 5.57523 2.02560L3.77532 3.82555C3.54133 4.06014 3.54133 4.43992 3.77532 4.67391C4.00991 4.90850 4.38969 4.90850 4.62367 4.67391L5.39943 3.89875V6.64961C5.39943 6.98139 5.66822 7.24958 5.9994 7.24958C6.33119 7.24958 6.59937 6.98139 6.59937 6.64961V3.86335L7.38293 4.61931Z'
      />
    </svg>
  )
}
